const headers = {
  name: "Material Issue Note",
  navigate: {
    tabs: [
      {
        name: "Material Issue",
        path: "/app/purchases/min",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;